export default "__VITE_ASSET__yR285UNN__"